import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=3d37d99e&scoped=true&"
import script from "./Appeal.vue?vue&type=script&lang=js&"
export * from "./Appeal.vue?vue&type=script&lang=js&"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=3d37d99e&scoped=true&lang=css&"
import style1 from "./Appeal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37d99e",
  null
  
)

export default component.exports